import React from 'react'

import { keyType } from '../../../constants/string'

import { ButtonWrapper, ButtonContainer, ButtonTitle, IconWrapper } from './MessageButton.style'

interface Props {
  isPrimaryButton: boolean
  isButtonDisabled?: boolean
  isModalButton? :boolean
  title: string
  target?: string
  href?: string
  onClickHandler?: () => void | Promise<void>
  icon?: JSX.Element | string
  isLoadingIframeData: boolean
}

const MessageButton: React.FC<Props> = ({
  isPrimaryButton,
  isButtonDisabled,
  isModalButton,
  title,
  target,
  href,
  onClickHandler,
  icon = '',
  isLoadingIframeData
}) => {
  const tabIndexValue = isLoadingIframeData ? -1 : isButtonDisabled ? -1 : 0

  const keyDownHandler = (e) => {
    const key = e.key.toLowerCase()
    switch (key) {
      case keyType.ENTER:
      case keyType.SPACE:
        !isButtonDisabled && onClickHandler()
        break
    }
  }

  return (
    <ButtonWrapper isModalButton={isModalButton}>
      <ButtonContainer
        data-test={isButtonDisabled ? 'message-button-disabled' : 'message-button'}
        role='button'
        tabIndex={tabIndexValue}
        target={target}
        href={href}
        isPrimaryButton={isPrimaryButton}
        isButtonDisabled={isButtonDisabled}
        onClick={onClickHandler}
        onKeyDown={keyDownHandler}
        hasIcon={icon}
      >
        {icon &&
          <IconWrapper>
            {icon}
          </IconWrapper>
        }
        <ButtonTitle
          isPrimaryButton={isPrimaryButton}
          isButtonDisabled={isButtonDisabled}
        >
          {title}
        </ButtonTitle>
      </ButtonContainer>
    </ButtonWrapper>
  )
}

export default MessageButton
